import React from 'react';
import '../styles/Home.css';

import HeroSection from '../components/Sections/HeroSection';
import SectionHeader from '../components/Sections/SectionHeader';
import ServiceCard from '../components/common/ServiceCard';
import CTASection from '../components/Sections/CTASection';

import {
  FaGlobe,
  FaUsers,
  FaGraduationCap,
  FaBullhorn,
  FaPalette,
  FaVideo,
  FaCopyright,
  FaMapMarkerAlt,
  FaCode,
  FaDev
} from 'react-icons/fa';

const Home = () => {

  const services = [
    {
      icon: FaCode,
      title: 'App Development',
      description: 'Custom mobile solutions for scalable businesses.',
      link: '/services#web-dev',
      tags: ['Flutter', 'Dart', 'React Native']
    },
    {
      icon: FaDev,
      title: 'Website Development',
      description: 'Custom website solutions for scalable businesses.',
      link: '/services#web-dev',
      tags: ['React', 'Next', 'E-commerce']
    },
    {
      icon: FaUsers,
      title: 'HR Consultancy',
      description: 'Professional hiring and HR solutions for organizations.',
      link: '/services#hr',
      tags: ['Recruitment', 'Staffing', 'Payroll']
    },
    {
      icon: FaGraduationCap,
      title: 'MPS Edu Tech',
      description: 'Industry-focused training and placement programs.',
      link: '/services#edu',
      tags: ['UI/UX', 'Full Stack', 'Internship']
    },
    {
      icon: FaBullhorn,
      title: 'Digital Marketing',
      description: 'Performance-driven marketing to grow your brand.',
      link: '/services#digital',
      tags: ['SEO', 'Ads', 'Social Media']
    },
    {
      icon: FaPalette,
      title: 'Graphic & Logo Design',
      description: 'Visual identity and branding design services.',
      link: '/services#graphic',
      tags: ['Logo', 'Branding', 'Creatives']
    },
    {
      icon: FaVideo,
      title: 'Video Editing',
      description: 'Professional video editing and social media content.',
      link: '/services#video',
      tags: ['Reels', 'YouTube', 'Shorts']
    },
    {
      icon: FaCopyright,
      title: 'Trademark & Legal',
      description: 'Protect your brand with legal and IP services.',
      link: '/services#legal',
      tags: ['Trademark', 'Copyright']
    },
    {
      icon: FaMapMarkerAlt,
      title: 'Local Advertising',
      description: 'Offline and hyper-local brand promotions.',
      link: '/services#local',
      tags: ['Hoardings', 'Pamphlets']
    }
  ];

  return (
    <div className="zoho-home">

      {/* HERO */}
      <section className="zoho-hero-section">
        <HeroSection
          title="MPeoples Business Solutions Pvt Ltd"
          subtitle="Enterprise-grade IT, marketing, and business solutions built for growth."
        />
      </section>

      {/* WHY CHOOSE US */}
      <section className="zoho-why-section">
        <div className="zoho-container">

          <SectionHeader
            title="Why Choose MPEOPLES?"
            subtitle="A trusted partner for digital and business transformation"
          />

          <div className="zoho-why-grid">

            <div className="zoho-why-card">
              <div className="zoho-why-value">360°</div>
              <h4 className="zoho-why-title">Complete Solutions</h4>
              <p className="zoho-why-text">
                Technology, marketing, HR, and legal under one roof.
              </p>
            </div>

            <div className="zoho-why-card">
              <div className="zoho-why-value">100+</div>
              <h4 className="zoho-why-title">Projects Delivered</h4>
              <p className="zoho-why-text">
                Proven delivery across multiple industries.
              </p>
            </div>

            <div className="zoho-why-card">
              <div className="zoho-why-value">50+</div>
              <h4 className="zoho-why-title">Happy Clients</h4>
              <p className="zoho-why-text">
                Long-term relationships built on trust.
              </p>
            </div>

            <div className="zoho-why-card">
              <div className="zoho-why-value">24/7</div>
              <h4 className="zoho-why-title">Support</h4>
              <p className="zoho-why-text">
                Dedicated assistance whenever you need it.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="zoho-services-section">
        <div className="zoho-container">

          <SectionHeader
            title="Our Core Services"
            subtitle="Enterprise-ready solutions designed for results"
          />

          <div className="zoho-services-grid">
            {services.map((service, index) => (
              <ServiceCard
                key={index}
                service={service}
                className="zoho-service-card"
              />
            ))}
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="zoho-cta-section">
        <CTASection />
      </section>

    </div>
  );
};

export default Home;
